<!-- =========================================================================================
  File Name: VerticalNavMenu.vue
  Description: Vertical NavMenu Component
  Component Name: VerticalNavMenu
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="parentx">

    <vs-sidebar
      id="sidebarMenu"
      class="v-nav-menu items-no-padding is_display sidebarMenu"
      v-model="isVerticalNavMenuActive"
      ref="verticalNavMenu"
      default-index="-1"
      :click-not-close="clickNotClose"
      :reduce-not-rebound="reduceNotRebound"
      parent="body"
      :hiddenBackground="clickNotClose"
      :reduce="reduce"
      >

      <div @mouseenter="mouseEnter" @mouseleave="mouseLeave" @mouseup="endResizeable">

        <!-- Header -->
        <div class="header-sidebar flex items-end justify-between" slot="header">

          <!-- Logo -->
          <router-link tag="div" class="vx-logo cursor-pointer flex items-center" :to="homeUrl">
            <logo class="w-10 mr-1 fill-current text-primary" />
            <span class="vx-logo-text text-primary" v-show="isMouseEnter || !reduce" v-if="title">{{ title }}</span>
          </router-link>
          <!-- /Logo -->

          <!-- Menu Buttons -->
          <div>
            <!-- Close Button -->
            <template v-if="showCloseButton">
              <feather-icon icon="XIcon" class="m-0 cursor-pointer" @click="$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)" />
            </template>

            <!-- Toggle Buttons -->
<!--            <template v-else-if="!showCloseButton && !verticalNavMenuItemsMin">
              <feather-icon
                id="btnVNavMenuMinToggler"
                class="mr-0 cursor-pointer"
                :icon="reduce ? 'CircleIcon' : 'DiscIcon'"
                svg-classes="stroke-current text-primary"
                @click="toggleReduce(!reduce)" />
            </template>-->
          </div>
          <!-- /Menu Toggle Buttons -->
        </div>
        <!-- /Header -->

        <!-- Header Shadow -->
       <div class="shadow-bottom" v-show="showShadowBottom" />

        <!-- Menu Items -->
        <component :is="scrollbarTag" ref="verticalNavMenuPs" class="scroll-area-v-nav-menu pt-2" :settings="settings" @ps-scroll-y="psSectionScroll" @scroll="psSectionScroll" :key="$vs.rtl">
          <template v-for="(item, index) in menuItemsUpdated">

            <!-- Group Header -->
            <span v-if="item.header && !verticalNavMenuItemsMin" class="navigation-header truncate" :key="`header-${index}`">
              {{ $t(item.i18n) || item.header }}
            </span>
            <!-- /Group Header -->

            <template v-else-if="!item.header">

              <!-- Nav-Item -->
              <v-nav-menu-item
                v-if="!item.submenu"
                :key="`item-${index}`"
                :index="index"
                :to="item.slug !== 'external' ? item.url : null"
                :href="item.slug === 'external' ? item.url : null"
                :icon="item.icon"
                :featherIcon="item.featherIcon"
                :target="item.target"
                :isDisabled="item.isDisabled"
                :slug="item.slug"
              >
                <span v-show="!verticalNavMenuItemsMin" class="truncate">{{
                  $t(item.i18n) || item.name
                }}</span>
                <vs-chip
                  class="ml-auto"
                  :color="item.tagColor"
                  v-if="item.tag && (isMouseEnter || !reduce)"
                  >{{ item.tag }}</vs-chip
                >
                <vs-chip
                  v-if="item.unreadNum"
                  class="ml-auto inbox-unread-num"
                  color="danger"
                  >{{ item.unreadNum }}</vs-chip
                >
              </v-nav-menu-item>

              <!-- Nav-Group -->
              <template>
                <v-nav-menu-group
                  :key="`group-${index}`"
                  :openHover="openGroupHover"
                  :group="item"
                  :menuLists="menuItemsUpdated"
                  :groupIndex="index"
                  :open="isGroupActive(item)" />
              </template>
              <!-- /Nav-Group -->
            </template>
          </template>
        </component>
        <!-- /Menu Items -->
      </div>
    </vs-sidebar>
    <div
      v-if="!$route.fullPath.includes('admin')"
      class="divider"
      :style="[
        {
          left: `${dividerPosition}`,
        },
      ]"
      @mousedown="startResizeable"
      @mouseup="endResizeable"
    ></div>

    <!-- Swipe Gesture -->
    <div
      v-if="!isVerticalNavMenuActive"
      class="v-nav-menu-swipe-area"
      v-hammer:swipe="onSwipeAreaSwipe" />
    <!-- /Swipe Gesture -->

    <!----Popup Confirm Delete Folder------>
    <vs-popup
      id="dialogDelete"
      title="メールサーバの削除"
      :active.sync="activeDelete"
      button-close-hidden
    >
      <div>
        <span> 選択したフォルダを削除しますか？ </span>
      </div>
      <div class="flex justify-end mt-4">
        <vs-button
          @click="deleteFolder"
          icon="delete"
          color="danger"
          class="mx-2"
          >削除</vs-button
        >
        <vs-button @click="activeDelete = false" icon="cancel" color="lightgrey"
          >キャンセル</vs-button
        >
      </div>
    </vs-popup>

    <!----Popup Create Edit Delete Folder------>
    <vs-popup
      id="addSubfolder"
      :title="action == 'EDIT' ? 'フォルダを編集' : 'フォルダーを追加'"
      :active.sync="$store.state.activePopup"
      button-close-hidden
    >
      <div>
        <div>
          <p class="my-2">フォルダ名</p>
          <vs-input
            placeholder="入力フォルダ名"
            v-validate.immediate="'required|folder_name'"
            name="フォルダー名に "
            v-model="foldername"
            style="width: 100%"
          />
          <span
            v-show="submited"
            class="mb-2 text-danger font-size-info"
            style="display: block"
            >{{ errors.first("フォルダー名に ") | convertError }}</span
          >
        </div>
      </div>
      <div class="flex justify-end mt-4">
        <vs-button
          v-if="action == 'ADD'"
          @click="addNewFolder"
          :disable="!validateForm && submited"
          icon="check"
          color="success"
          class="mx-2"
          >追加</vs-button
        >
        <vs-button
          v-if="action == 'EDIT'"
          @click="editFolder"
          :disable="!validateForm && submited"
          icon="save"
          color="success"
          class="mx-2"
          >編集</vs-button
        >
        <vs-button
          v-if="action == 'EDIT'"
          @click="activeDelete = true"
          icon="delete"
          color="danger"
          class="mx-2"
          >消去</vs-button
        >
        <vs-button
          @click="$store.commit('TOGGLE_POPUP', { type: 'CANCEL' })"
          icon="cancel"
          color="lightgrey"
          >閉じる</vs-button
        >
      </div>
    </vs-popup>
  </div>
</template>


<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import VNavMenuGroup from './VerticalNavMenuGroup.vue'
import VNavMenuItem from './VerticalNavMenuItem.vue'

import Logo from '../Logo.vue'

import { mapActions } from 'vuex'
export default {
  name: 'v-nav-menu',
  components: {
    VNavMenuGroup,
    VNavMenuItem,
    VuePerfectScrollbar,
    Logo
  },
  props: {
    logo:             { type: String },
    openGroupHover:   { type: Boolean, default: false },
    parent:           { type: String },
    reduceNotRebound: { type: Boolean, default: true },
    navMenuItems:     { type: Array,   required: true },
    title:            { type: String },
    homeUrl:          { type: String, required: true }
  },
  data() {
    return {
      clickNotClose       : false, // disable close navMenu on outside click
      isMouseEnter        : false,
      reduce              : false, // determines if navMenu is reduce - component property
      showCloseButton     : false, // show close button in smaller devices
      settings            : {      // perfectScrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed        : 1,
        swipeEasing       : true
      },
      showShadowBottom    : false,
      submited: false,
      activeDelete: false,
      dividerPosition: "260px",
      widthSideBarDefault: 260,
    };
  },
  computed: {
    isGroupActive () {
      return (item) => {
        const path        = this.$route.fullPath
        const routeParent = this.$route.meta ? this.$route.meta.parent : undefined
        let open          = false

        const func = (item) => {
          if (item.submenu) {
            item.submenu.forEach((item) => {
              if (item.url && (path === item.url || routeParent === item.slug)) {
                open = true;
              } else if (item.submenu) {
                func(item);
              }
            });
          }
        };
        func(item)
        return open
      };
    },
    menuItemsUpdated() {
      let clone = this.navMenuItems.slice()

      // for (const [index, item] of this.navMenuItems.entries()) {
      //   if (item.header && item.items.length && (index || 1)) {
      //     const i = clone.findIndex(ix => ix.header === item.header)
      //     for (const [subIndex, subItem] of item.items.entries()) {
      //       clone.splice(i + 1 + subIndex, 0, subItem)
      //     }
      //   }
      // }
      // clone = clone.map(item => {
      //   item.level = 1
      //   item.show = true
      //   if(item.submenu && item.submenu.length) {
      //     item.submenu = item.submenu.map(_item => {
      //       _item.level = 2;
      //       _item.show = false;
      //       if(_item.submenu && _item.submenu.length) {
      //         _item.submenu = _item.submenu.map(__item => {
      //           __item.level = 3;
      //           __item.show = false;
      //           return __item;
      //         })
      //       }
      //       return _item;
      //     })
      //   }
      //   return item;
      // })
      return clone
    },
    isVerticalNavMenuActive: {
      get ()    { return this.$store.state.isVerticalNavMenuActive },
      set (val) { this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', val) }
    },
    layoutType () { return this.$store.state.mainLayoutType },
    reduceButton: {
      get ()    { return this.$store.state.reduceButton },
      set (val) { this.$store.commit('TOGGLE_REDUCE_BUTTON', val) }
    },
    isVerticalNavMenuReduced () { return Boolean(this.reduce && this.reduceButton) },
    verticalNavMenuItemsMin ()  { return this.$store.state.verticalNavMenuItemsMin },
    scrollbarTag ()             { return this.$store.getters.scrollbarTag          },
    windowWidth ()              { return this.$store.state.windowWidth             },
    foldername: {
      get() {
        return this.$store.state.folder.name;
      },
      set(val) {
        this.$store.commit("CHANGE_FOLDER_NAME", val);
      },
    },
    action() {
      return this.$store.state.folder.action;
    },
    validateForm() {
      return !this.errors.any();
    },
  },
  watch: {
    $route() {
      if (this.isVerticalNavMenuActive && this.showCloseButton)
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);
    },
    reduce (val) {
      const verticalNavMenuWidth = val ? 'reduced' : this.$store.state.windowWidth < 1200 ? 'no-nav-menu' : 'default'
      this.$store.dispatch('updateVerticalNavMenuWidth', verticalNavMenuWidth)

      setTimeout(function () {
        window.dispatchEvent(new Event('resize'))
      }, 100)
    },
    layoutType ()   { this.setVerticalNavMenuWidth() },
    reduceButton () { this.setVerticalNavMenuWidth() },
    windowWidth ()  { this.setVerticalNavMenuWidth() }
  },
  methods: {
    ...mapActions({
      getListMailBox: "receiveMail/getListMailBox",
      createMailFolder: "mailFolder/createMailFolder",
      updateMailFolder: "mailFolder/updateMailFolder",
      deleteMailFolder: "mailFolder/deleteMailFolder",
      getFolderReceiveMail: "mailRule/getFolderReceiveMail",
      getRuleReceiveMail: "mailRule/getRuleReceiveMail",
    }),
    onMenuSwipe(event) {
      if (event.direction === 4 && this.$vs.rtl) {

        // Swipe Right
        if (this.isVerticalNavMenuActive && this.showCloseButton) this.isVerticalNavMenuActive = false

      } else if (event.direction === 2 && !this.$vs.rtl) {

        // Swipe Left
        if (this.isVerticalNavMenuActive && this.showCloseButton) this.isVerticalNavMenuActive = false
      }
    },
    onSwipeAreaSwipe (event) {

      if (event.direction === 4 && !this.$vs.rtl) {

        // Swipe Right
        if (!this.isVerticalNavMenuActive && this.showCloseButton) this.isVerticalNavMenuActive = true
      } else if (event.direction === 2 && this.$vs.rtl) {

        // Swipe Left
        if (!this.isVerticalNavMenuActive && this.showCloseButton) this.isVerticalNavMenuActive = true
      }
    },
    psSectionScroll () {
      const scroll_el = this.$refs.verticalNavMenuPs.$el || this.$refs.verticalNavMenuPs
      this.showShadowBottom = scroll_el.scrollTop > 0
    },
    mouseEnter () {
      if (this.reduce) this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false)
      this.isMouseEnter = true
    },
    mouseLeave () {
      if (this.reduce) this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', true)
      this.isMouseEnter = false
    },
    //Resizeable SideBar
    handleResizeable(e) {
      let vsSidebar = document.getElementById("sidebarMenu");
      let vsContentArea = document.getElementById("content-area");
      let vsNavBar = document.getElementById("vs_navbar");
      //SideBar
      vsSidebar.childNodes[1].childNodes[1].style.width = e.pageX - 5 + "px";
      vsSidebar.childNodes[1].childNodes[1].style.minWidth =
        this.widthSideBarDefault + "px";
      if (e.pageX <= this.widthSideBarDefault) {
        //Block resizeable when widthSideBar<=260
        this.dividerPosition = this.widthSideBarDefault + "px";
        //Navbar
        vsNavBar.style.width =
          window.innerWidth - this.widthSideBarDefault + "px";
        vsNavBar.style.marginLeft = "0px";
        //ContentArea
        vsContentArea.style.width =
          window.innerWidth - this.widthSideBarDefault + "px";
        vsContentArea.style.marginLeft = "0px";
      } else {
        this.dividerPosition = e.pageX + "px";
        //Navbar
        vsNavBar.style.width = window.innerWidth - e.pageX - 16.8 + "px";
        //ContentArea
        vsContentArea.style.width = window.innerWidth - e.pageX - 15 + "px";
        vsContentArea.style.marginLeft =
          e.pageX - this.widthSideBarDefault + "px";
      }
    },
    startResizeable() {
      document.addEventListener("mousemove", this.handleResizeable);
    },
    endResizeable() {
      document.removeEventListener("mousemove", this.handleResizeable);
    },
    setVerticalNavMenuWidth() {
      if (this.windowWidth > 1200) {
        if (this.layoutType === 'vertical') {
          // Set reduce
          this.reduce = !!this.reduceButton

          // Open NavMenu
          this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)

          // Set Menu Items Only Icon Mode
          const verticalNavMenuItemsMin = !!(this.reduceButton && !this.isMouseEnter)
          this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', verticalNavMenuItemsMin)

          // Menu Action buttons
          this.clickNotClose   = true
          this.showCloseButton = false

          const verticalNavMenuWidth   = this.isVerticalNavMenuReduced ? 'reduced' : 'default'
          this.$store.dispatch('updateVerticalNavMenuWidth', verticalNavMenuWidth)

          return
        }
      }

      // Close NavMenu
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)

      // Reduce button
      if (this.reduceButton) this.reduce = false

      // Menu Action buttons
      this.showCloseButton = true
      this.clickNotClose   = false

      // Update NavMenu Width
      this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')

      // Remove Only Icon in Menu
      this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false)


      // if(this.layoutType === 'vertical' || (this.layoutType === 'horizontal' && this.windowWidth < 1200))
      // if (this.windowWidth < 1200) {

      //   // Close NavMenu
      //   this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)

      //   // Reduce button
      //   if (this.reduceButton) this.reduce = false

      //   // Menu Action buttons
      //   this.showCloseButton = true
      //   this.clickNotClose   = false

      //   // Update NavMenu Width
      //   this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')

      //   // Remove Only Icon in Menu
      //   this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', false)

      // } else {

      //   // Set reduce
      //   this.reduce = this.reduceButton ? true : false

      //   // Open NavMenu
      //   this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)

      //   // Set Menu Items Only Icon Mode
      //   const verticalNavMenuItemsMin = (this.reduceButton && !this.isMouseEnter) ? true : false
      //   this.$store.commit('UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN', verticalNavMenuItemsMin)

      //   // Menu Action buttons
      //   this.clickNotClose   = true
      //   this.showCloseButton = false

      //   const verticalNavMenuWidth   = this.isVerticalNavMenuReduced ? "reduced" : "default"
      //   this.$store.dispatch('updateVerticalNavMenuWidth', verticalNavMenuWidth)
      // }
    },
    toggleReduce (val) {
      this.reduceButton = val
      this.setVerticalNavMenuWidth()
    },
    async addNewFolder() {
      if (!this.validateForm) {
        this.submited = true;
      } else {
        let data = {
          parent: this.$store.state.folder.id,
          mailBox: this.$store.state.folder.mail_server,
          name: this.foldername,
        };
        if (await this.createMailFolder(data)){
          await this.getListMailBox();
          await this.getFolderReceiveMail(this.$route.params.email)
          this.$store.commit("TOGGLE_POPUP", { type: "CANCEL" });
        }
      }
    },
    async editFolder() {
      if (!this.validateForm){
        this.submited = true;
      }
      else{
        let data = {
          id: this.$store.state.folder.id,
          mailBox: this.$store.state.folder.mail_server,
          name: this.foldername,
        }
        if (await this.updateMailFolder(data)){
          await this.getListMailBox();
          await this.getFolderReceiveMail(this.$route.params.email)
          this.$store.commit("TOGGLE_POPUP", { type: "CANCEL" });
          //Calculate the folder name
          if (this.$route.fullPath.includes(this.$store.state.folder.url)){
            let path = this.$route.fullPath;
            let pathArr = path.split("/");
            pathArr[pathArr.length - 1] = this.foldername;
            path = pathArr.join("/");
            //Reload component
            this.$router.push({ path });
          }
        }
      }
    },
    async deleteFolder() {
      let data = {
        id: this.$store.state.folder.id,
        mailBox: this.$store.state.folder.mail_server,
      };
      this.activeDelete = false;
      await this.deleteMailFolder(data);
      let mailServe = this.$route.params.email ? this.$route.params.email : data.mailBox;
      this.$store.commit("TOGGLE_POPUP", { type: "CANCEL" });
      await Promise.all([
        this.getFolderReceiveMail(mailServe),
        this.getRuleReceiveMail(mailServe),
        this.getListMailBox(),
      ]);
      if (this.$route.fullPath.includes(this.$store.state.folder.mail_server)){
        this.$router.push({
        path: `/box/${this.$store.state.folder.mail_server}`,
      });
      }
    },
  },
  mounted() {
    this.setVerticalNavMenuWidth();
  },
};
</script>


<style lang="scss">
.divider {
  height: 100%;
  width: 20px;
  background: transparent;
  transform: translateX(-3px);
  position: fixed;
  top: 0;
  z-index: 1;
  cursor: ew-resize;
}
#content-area {
  width: calc(100% - 260px);
  margin-left: 0;
}
@import "@/assets/scss/vuexy/components/verticalNavMenu.scss"
</style>
